import { Pipe, PipeTransform } from "@angular/core";
import { FiltersType } from "src/components/shared-components/enum/enumFilters";
import { Filter } from "src/components/shared-components/class/general-classes/filter";
import moment from "moment";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

@Pipe({
    name: "filterDateFormatter",
    standalone: false
})
export class FilterDateFormatterPipe implements PipeTransform {
  private _fromDay: string = "fromDay";
  private _toDay: string = "toDay";
  private _fromDaySolution: string = "fromDaySolution";
  private _toDaySolution: string = "toDaySolution";
  private _fromTime: string = "fromTime";
  private _toTime: string = "toTime";
  private _idAll: number = -1;

  /**
   *This pipe takes a Map<string,string> and an array of Filter[] format and returns a Map<string,string> 
   containing all the initail data except the fromTime and toTime because the fromDay and toDay is changed to a date-time format
   * @param filterData: data received from filters
   * @param  tableInfoFilters: tableInfo filters array
   * @returns a Map<string,string> containing all initial data without the fromTime and toTime but the fromDay and toDay in a date-time format
   */
  transform(
    filterData: Map<string, string>,
    tableInfoFilters: Filter[]
  ): Map<string, string> {
    let fillFilteredData: Map<string, string> = new Map<string, string>();
    let fromDay: string = filterData.get(this._fromDay);
    let toDay: string = filterData.get(this._toDay);
    let fromTime: string = filterData.get(this._fromTime);
    let toTime: string = filterData.get(this._toTime);
    let fromDate: moment.Moment = null;
    let toDate: moment.Moment = null;

    if (fromDay) {
      fromDate = moment(
        fromTime ? `${fromDay} ${fromTime}` : fromDay,
        fromTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD"
      );
      fromDay = this.formatDate(fromDate.format(), 2, true);
      fillFilteredData.set(this._fromDay, fromDay);
    }
    if (toDay) {
      toDate = moment(
        toTime ? `${toDay} ${toTime}:59` : toDay,
        toTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD"
      );
      toDay = this.formatDate(toDate.format(), 2, true);
      fillFilteredData.set(this._toDay, toDay);
    }

    fromDay = filterData.get(this._fromDaySolution);
    toDay = filterData.get(this._toDaySolution);

    if (fromDay) {
      fromDate = moment(fromDay, "YYYY-MM-DD");
      fromDay = this.formatDate(fromDate.format(), 1, true);
      fillFilteredData.set(this._fromDaySolution, fromDay);
    }
    if (toDay) {
      toDate = moment(toDay, "YYYY-MM-DD");
      toDay = this.formatDate(toDate.format(), 1, true);
      fillFilteredData.set(this._toDaySolution, toDay);
    }

    fillFilteredData = this.fillFilterData(fillFilteredData, filterData);

    if (fromTime) {
      fillFilteredData.delete(this._fromTime);
    }
    if (toTime) {
      fillFilteredData.delete(this._toTime);
    }

    let combo = tableInfoFilters.find((x) => x.Kind === FiltersType.combo);
    if (combo) {
      let value = filterData.get(combo.Name);
      if (value === this._idAll.toString()) {
        fillFilteredData.delete(combo.Name);
      }
    }

    return fillFilteredData;
  }

  /**
   * If the starting date is greater than the
   * ending date it causes an error toast to appear.
   * @param startDate starting date
   * @param endDate ending date
   */
  private fillFilterData(
    newFilterData: Map<string, string>,
    oldFilterData: Map<string, string>
  ): Map<string, string> {
    const filteredEntries = Array.from(oldFilterData).reduce(
      (filteredResult, [key, value]) => {
        if (!newFilterData.has(key)) {
          filteredResult.set(key, value);
        }
        return filteredResult;
      },
      new Map<string, string>()
    );

    const filteredResult = new Map([...newFilterData, ...filteredEntries]);

    return filteredResult;
  }

  /**
   * Returns the formatted date
   * @param date
   * @param type :specifies the desired date time format
   * @param before boolean
   * @returns string
   */
  private formatDate(date: string, type: number, before: boolean): string {
    let beforeFormat = "";
    let afterFormat = "";

    switch (type) {
      case 1:
        beforeFormat =
          MomentFormats.MOMENT_DATETIME_FORMAT_SHORT_DATE_INVERSE;
        afterFormat = before
          ? MomentFormats.MOMENT_DATETIME_FORMAT_SHORT_DATE_STRAIGHT
          : "MM-DD-YYYY";
        break;
      case 2:
        beforeFormat = MomentFormats.MOMENT_DATETIME_FORMAT;
        afterFormat = before
          ? MomentFormats.MOMENT_DATETIME_FORMAT_SHORT
          : "MM-DD-YYYY HH:mm:ss";
        break;
    }

    return moment(date, beforeFormat).format(afterFormat);
  }
}
